module.exports = __webpack_public_path__ + "img/scritta-logo.ecfa6fb2.svg";